// @ts-nocheck

import { uniqueId as _uniqueId } from 'lodash';

import { AppActionTypes } from '../types/actions/app';

export const flashmessagesInitialState = {};

export default (state = flashmessagesInitialState, action) => {
  switch (action.type) {
    case AppActionTypes.ADD_FLASH_MESSAGE: {
      const { scope, severity, message, type, ...rest } = action.payload;
      const id = _uniqueId('flashmessage_');
      return {
        ...state,
        [scope]: {
          ...state[scope],
          [id]: { id, scope, severity, message, type, ...rest },
        },
      };
    }
    case AppActionTypes.DEL_FLASH_MESSAGE: {
      const { scope, id } = action.payload;
      const nextScope = { ...state[scope] };
      if (nextScope[id] !== undefined) {
        delete nextScope[id];
        return {
          ...state,
          [scope]: nextScope,
        };
      }
      return state;
    }
    default:
      return state;
  }
};
